import { FareOptionsResponse, CruiseExpiration } from '@ssc-booking/api-contracts';
import * as Amount from '@ssc-booking/api-contracts/src/amount';
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import { CruiseCode } from "@ssc-booking/functional-support"
import * as DateTime from "@silversea-ssc/data-types/DateTime"
import { makeSingleFareOption } from "../../../app-core/features/_common/read-models/fare-card/test-support/helpers"
import { cruiseCode } from "./cruisecode"

const expirationDays = 7
const expirationDate = DateTime.addDays(DateTime.now(), expirationDays)

export const d2dBusinessPricePerPax = 1298

export default FareOptionsResponse.build({
    cruiseCode: CruiseCode.buildUnsafe(cruiseCode),
    cruiseExpiration: CruiseExpiration.build({ days: expirationDays, date: expirationDate }),
    occupancy: Occupancy.of(2),
    options: [
        makeSingleFareOption(
            "DoorToDoorV2",
            [
                {
                    airFare: "Business",
                    detailByGuest: [
                        {
                            paxNumber: 1,
                            amount: Amount.of(d2dBusinessPricePerPax, "USD"),
                            isPromotional: true,
                        },
                        {
                            paxNumber: 2,
                            amount: Amount.of(d2dBusinessPricePerPax, "USD"),
                            isPromotional: true,
                        },
                    ],
                },
                {
                    airFare: "Economy",
                    detailByGuest: [
                        {
                            paxNumber: 1,
                            amount: Amount.of(0, "USD"),
                            isPromotional: true,
                        },
                        {
                            paxNumber: 2,
                            amount: Amount.of(0, "USD"),
                            isPromotional: true,
                        },
                    ],
                },
            ],
            [
                {
                    code: "ABQ",
                    name: "Albuquerque, NM",
                },
                {
                    code: "ATL",
                    name: "Atlanta, GA",
                },
                {
                    code: "AUS",
                    name: "Austin, TX",
                },
                {
                    code: "BWI",
                    name: "Baltimore, MD",
                },
                {
                    code: "BOS",
                    name: "Boston, MA",
                },
                {
                    code: "CHS",
                    name: "Charleston, SC",
                },
                {
                    code: "CLT",
                    name: "Charlotte, NC",
                },
                {
                    code: "ORD",
                    name: "Chicago, IL",
                },
                {
                    code: "CVG",
                    name: "Cincinnati, KY",
                },
                {
                    code: "CLE",
                    name: "Cleveland, OH",
                },
                {
                    code: "CMH",
                    name: "Columbus, OH",
                },
                {
                    code: "DFW",
                    name: "Dallas, TX",
                },
                {
                    code: "DEN",
                    name: "Denver, CO",
                },
                {
                    code: "DTW",
                    name: "Detroit, MI",
                },
                {
                    code: "FLL",
                    name: "Ft Lauderdale, FL",
                },
                {
                    code: "IAH",
                    name: "Houston, TX",
                },
                {
                    code: "IND",
                    name: "Indianapolis, IN",
                },
                {
                    code: "MCI",
                    name: "Kansas City, MO",
                },
                {
                    code: "LAS",
                    name: "Las Vegas, NV",
                },
                {
                    code: "LIT",
                    name: "Little Rock, AR",
                },
                {
                    code: "LAX",
                    name: "Los Angeles, CA",
                },
                {
                    code: "SDF",
                    name: "Louisville, KY",
                },
                {
                    code: "MEM",
                    name: "Memphis, TN",
                },
                {
                    code: "MIA",
                    name: "Miami, FL",
                },
                {
                    code: "MSP",
                    name: "Minneapolis, MN",
                },
                {
                    code: "BNA",
                    name: "Nashville, TN",
                },
                {
                    code: "MSY",
                    name: "New Orleans, LA",
                },
                {
                    code: "NYC",
                    name: "New York, NY",
                },
                {
                    code: "OKC",
                    name: "Oklahoma, OK",
                },
                {
                    code: "OMA",
                    name: "Omaha, NE",
                },
                {
                    code: "MCO",
                    name: "Orlando, FL",
                },
                {
                    code: "PHL",
                    name: "Philadelphia, PA",
                },
                {
                    code: "PHX",
                    name: "Phoenix, AZ",
                },
                {
                    code: "PDX",
                    name: "Portland, OR",
                },
                {
                    code: "SLC",
                    name: "Salt Lake Cty, UT",
                },
                {
                    code: "SAT",
                    name: "San Antonio, TX",
                },
                {
                    code: "SFO",
                    name: "San Francisco, CA",
                },
                {
                    code: "SEA",
                    name: "Seattle, WA",
                },
                {
                    code: "STL",
                    name: "St. Louis, MO",
                },
                {
                    code: "TPA",
                    name: "Tampa, FL",
                },
                {
                    code: "TUS",
                    name: "Tucson, AZ",
                },
                {
                    code: "TUL",
                    name: "Tulsa, OK",
                },
                {
                    code: "WAS",
                    name: "Washington DC",
                },
            ],
        ),
        makeSingleFareOption("PortToPortV2", []),
        makeSingleFareOption("Essential", []),
    ],
})
